import React from 'react';
import CardContent from './components/CardContent/CardContent';

import * as Styled from './Card.styled';

/**
 * A `Card` is used to render content within a styled rectangle.
 */
const Card = (props) => <Styled.Card {...props} />;

export default Card;
export { CardContent };
